import { Modal, ModalBody } from '@/components/modal/modal';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './insurance-coverage-modal.module.css';
import clsx from 'clsx';

interface InsuranceCoverageModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const translationBase = 'visit.insuranceInformation.coverage.modal';

const components = ['deductible', 'outOfPocketMaximum', 'orderOfOperations'] as const;

type Component = (typeof components)[number];

export function InsuranceCoverageModal({ isOpen, onClose }: InsuranceCoverageModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="h4">{t(`${translationBase}.title`)}</h2>
      <ModalBody className={styles.modalBody}>
        <p>{t(`${translationBase}.components`)}</p>
        <ul className={styles.list}>
          <li>{t(`${translationBase}.items.coverage`)}</li>
          <li>{t(`${translationBase}.items.deductible`)}</li>
          <li>{t(`${translationBase}.items.outOfPocketMaximum`)}</li>
        </ul>
        <p>{t(`${translationBase}.deductiblesNotice`)}</p>
        <p>{t(`${translationBase}.additionalInfo`)}</p>
        <p className="bold">{t(`${translationBase}.definitions.title`)}</p>
        {components.map((component) => (
          <ComponentDescription key={component} component={component} />
        ))}
      </ModalBody>
    </Modal>
  );
}
interface ComponentDescriptionProps {
  component: Component;
}

function ComponentDescription({ component }: ComponentDescriptionProps) {
  const { t } = useTranslation();

  return (
    <p>
      <span className={clsx('bold', 'italic', styles.component)}>
        {t(`${translationBase}.definitions.${component}.title`)}
      </span>
      {t(`${translationBase}.definitions.${component}.description`)}
    </p>
  );
}
